// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachMonthOfInterval as fn } from "../eachMonthOfInterval.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachMonthOfIntervalWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default eachMonthOfIntervalWithOptions;
